/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/product/index.js}] */
"use strict";
(() => {
  // _js/standalone/product/index.js
  var Vue = window.Vue, Shopify = window.Shopify, Swiper = window.Swiper, $ = window.$, V_PRODUCT_SELECTOR = "\
#v-product-main", { createApp } = Vue, createProductApp = (v_product, productJsonData) => {
    if (!v_product || !productJsonData)
      return null;
    let product = JSON.parse(productJsonData.value), $optionsWithValues = v_product.querySelector(
      "[data-product-options-with-values-json]"
    );
    if ($optionsWithValues) {
      let options_with_values = JSON.parse($optionsWithValues.value);
      product.options_with_values = options_with_values;
    }
    let $selectedVariantJsonData = v_product.querySelector(
      "[data-selected-variant-json]"
    );
    $selectedVariantJsonData && (product.selected_variant = JSON.parse($selectedVariantJsonData.value));
    let $variantsMetafieldData = v_product.querySelector(
      "[data-variants-metafields]"
    ), variantsMetafieldData = [];
    $variantsMetafieldData && (variantsMetafieldData = JSON.parse($variantsMetafieldData.value));
    let $productMainWrap = document.querySelector("#product-main"), RV_key = "recently-viewed", RV_items = JSON.
    parse(localStorage.getItem(RV_key)) || [], RV_max_items = 6, selected_variant_inventory;
    return createApp({
      delimiters: ["${", "}"],
      data() {
        return {
          product,
          swiper_main: null,
          swiper_related_products: null,
          variantsMetafieldData,
          RV_items,
          RV_products: []
        };
      },
      computed: {
        selected_variant() {
          return this.product.selected_variant;
        },
        size_option() {
          return this.product.options_with_values && this.product.options_with_values.find((op) => op.
          name === "Size");
        },
        isSelectedVariantLowStock() {
          let isSelectedVariantLowStock = !1, variant_data = this.variantsMetafieldData.find(
            (item) => item.variant_id === this.selected_variant.id
          );
          if (variant_data) {
            let inventory = variant_data.inventory_qty;
            isSelectedVariantLowStock = inventory > 0 && inventory < 8;
          }
          return isSelectedVariantLowStock;
        },
        isProductSoldout() {
          return !this.product.available;
        }
      },
      watch: {
        isSelectedVariantLowStock() {
          this.updateVariantLowStock();
        }
      },
      mounted() {
        this.initSwiperMain(), this.initDOMevents(), this.initSwiperRelatedProducts(), this.addRecentlyViewed(),
        this.getRecentlyViewedProductsJS(), this.updateVariantLowStock(), this.variantChangeEvents(),
        this.initDropdowns();
      },
      methods: {
        initDropdowns() {
          $(".select-custom select").each((index, select) => {
            let $select = $(select);
            $select.selectric({
              disableOnMobile: !1,
              nativeOnMobile: !0,
              onInit() {
                $select.closest(".selectric-wrapper").find("b").after('<span class="caret"></span>');
              },
              onChange(target) {
                target.dispatchEvent(new Event("change", { bubbles: !0 }));
              }
            });
          });
        },
        initDOMevents() {
          this.notifyFormEvents();
        },
        variantChangeEvents() {
          document.addEventListener("variant:change", () => {
            this.updateVariantLowStock(), this.updateButtonState();
          });
        },
        notifyFormEvents() {
          document.addEventListener("variant:change", (e) => {
            let $notify = document.querySelector(".product-notify-stock");
            if (!$notify || !$notify.querySelector("summary"))
              return;
            let $details = $notify.querySelector("details");
            if (!$details)
              return;
            let variant = e.detail.variant;
            if ($notify.querySelectorAll("input:checked").forEach(($input) => {
              $input.checked = !1;
            }), variant.available)
              $details.removeAttribute("open");
            else {
              let $size = $notify.querySelector(
                `input[name="size"][data-variant="${variant.id}"]`
              );
              $size && ($size.checked = !0, $details.setAttribute("open", !0));
            }
            this.product.selected_variant = variant;
          });
        },
        initSwiperMain() {
          this.swiper_main = new Swiper(".swiper-product-images", {
            loop: !0,
            pagination: {
              el: ".swiper-product-images .swiper-pagination",
              clickable: !0
            },
            navigation: {
              nextEl: ".swiper-product-images .swiper-button-next",
              prevEl: ".swiper-product-images .swiper-button-prev"
            },
            breakpoints: {},
            on: {}
          }), document.querySelectorAll(".product-images-thumbs .product-thumb").forEach(($thumb) => {
            $thumb.addEventListener("click", (e) => {
              let index = e.currentTarget.dataset.index;
              this.slideTo(index);
            });
          });
        },
        initSwiperRelatedProducts() {
          this.swiper_related_products = new Swiper(".related-produts-swiper", {
            loop: !0,
            slidesPerView: 3,
            spaceBetween: 5,
            pagination: {},
            breakpoints: {
              1024: {
                slidesPerView: 4,
                spaceBetween: 10
              },
              1365: {
                slidesPerView: 6,
                spaceBetween: 10
              }
            },
            navigation: {
              nextEl: ".related-produts-swiper .swiper-button-next",
              prevEl: ".related-produts-swiper .swiper-button-prev"
            },
            on: {}
          });
        },
        slideTo(index) {
          this.swiper_main.slideTo(index);
        },
        submitBackinStockForm(e) {
          Shopify.theme.utils.submitBackinStockForm(e);
        },
        addRecentlyViewed() {
          if (!(this.RV_items.map((item) => item.handle).indexOf(
            this.product.handle
          ) !== -1)) {
            let RV_item = { handle: this.product.handle };
            RV_items.unshift(RV_item), localStorage.setItem(RV_key, JSON.stringify(RV_items));
          }
        },
        getRecentlyViewedProductsJS() {
          let RV_promises = this.RV_items.map(
            (p) => fetch(`/products/${p.handle}.js`).then((res) => res.text())
          ), RV_products = [];
          Promise.all(RV_promises).then((res) => {
            res.filter((item) => item).forEach((item) => {
              JSON.parse(item).handle !== this.product.handle && RV_products.push(JSON.parse(item));
            });
          }).catch(console.error).finally(() => {
            this.RV_products = RV_products.slice(0, RV_max_items);
          });
        },
        updateVariantLowStock() {
          if (!this.size_option || !$productMainWrap)
            return;
          let $sizeInput = document.querySelector(
            '[data-option="size"] input:checked'
          );
          if (!$sizeInput)
            return;
          let size = $sizeInput.value, $variantRadios = $productMainWrap.querySelector("variant-radi\
os"), $size = $productMainWrap.querySelector(
            `input[value="${size}"] + label`
          ), offsetLeft = 0;
          if ($variantRadios && $size) {
            let container_offsetLeft = $variantRadios.offsetLeft;
            offsetLeft = $size.offsetLeft - container_offsetLeft;
          }
          $productMainWrap.querySelectorAll(".low-stock").forEach(($stock) => {
            let isSelectedVariantLowStock = !1;
            setTimeout(() => {
              let $variantInput = document.querySelector(
                'product-form.product-form input[name="id"]'
              );
              if (!$variantInput)
                return;
              let variant_data = this.variantsMetafieldData.find(
                (item) => item.variant_id === parseInt($variantInput.value)
              );
              if (variant_data) {
                let inventory = variant_data.inventory_qty;
                selected_variant_inventory = inventory, isSelectedVariantLowStock = inventory > 0 &&
                inventory < 8;
              }
              $stock.classList[isSelectedVariantLowStock ? "add" : "remove"](
                "visible"
              ), $stock.style.marginLeft = `${offsetLeft}px`;
            });
          }, 100);
        },
        updateButtonState() {
          let soldOutTag = "sold_out", hasSoldOutTag = !1;
          this.product.tags.some(
            (tag) => tag.toLowerCase() === soldOutTag.toLowerCase()
          ) && (hasSoldOutTag = !0);
          let isSoldout = this.selected_variant.available === !1 && hasSoldOutTag === !0, isNotifyBackInStock = this.
          selected_variant.available === !1 && hasSoldOutTag === !1;
          isNotifyBackInStock ? ($productMainWrap.querySelector(
            ".product-form-wrap square-placement"
          ) && ($productMainWrap.querySelector(
            ".product-form-wrap square-placement"
          ).style.height = "0"), $productMainWrap.querySelector('[data-shopify="payment-button"]') &&
          ($productMainWrap.querySelector(
            '[data-shopify="payment-button"]'
          ).style.display = "none")) : ($productMainWrap.querySelector(
            ".product-form-wrap square-placement"
          ) && ($productMainWrap.querySelector(
            ".product-form-wrap square-placement"
          ).style.height = null), $productMainWrap.querySelector('[data-shopify="payment-button"]') &&
          ($productMainWrap.querySelector(
            '[data-shopify="payment-button"]'
          ).style.display = "block")), setTimeout(() => {
            let $submitButton = $productMainWrap.querySelector(
              ".product-form__submit"
            ), $notifyMeButton = $productMainWrap.querySelector(
              ".product-form__notify-me"
            );
            if (!$submitButton)
              return;
            let $submitButtonSpan = $submitButton.querySelector("span");
            this.selected_variant.available ? ($submitButton.disabled = !1, $submitButton.name = "ad\
d", $submitButtonSpan && (typeof selected_variant_inventory < "u" && selected_variant_inventory <= 0 ?
            ($submitButtonSpan.textContent = "Pre-order", $productMainWrap.querySelector('input[name\
="properties[]"]') && ($productMainWrap.querySelector(
              'input[name="properties[]"]'
            ).disabled = !1)) : ($submitButtonSpan.textContent = "Add to bag", $productMainWrap.querySelector(
            'input[name="properties[]"]') && ($productMainWrap.querySelector(
              'input[name="properties[]"]'
            ).disabled = !0))), $submitButton.classList.remove("hidden")) : ($submitButton.disabled =
            !0, $submitButton.name = "add", $submitButtonSpan && ($submitButtonSpan.textContent = "S\
old Out"), $submitButton.classList.add("hidden")), $notifyMeButton && (isNotifyBackInStock ? ($notifyMeButton.
            setAttribute(
              "data-variant-id",
              this.selected_variant.id.toString()
            ), $notifyMeButton.style.display = "") : $notifyMeButton.style.display = "none");
          }, 100);
        }
      }
    });
  }, handleSectionLoad = (event) => {
    let section = ((evt) => {
      if (evt.target == null)
        return null;
      let sectionId = "detail" in evt && evt.detail !== null && typeof evt.detail == "object" && "se\
ctionId" in evt.detail && typeof evt.detail.sectionId == "string" && evt.detail.sectionId.length > 0 ?
      evt.detail.sectionId : null;
      return sectionId == null ? null : evt.target instanceof HTMLElement && evt.target.getAttribute(
      "id") === "shopify-section-" + sectionId ? evt.target : null;
    })(event);
    if (section == null || section.classList?.contains("main-product-page") === !1)
      return;
    let $new_v_product = section.querySelector(V_PRODUCT_SELECTOR);
    if (!$new_v_product)
      return;
    let $new_productJsonData = $new_v_product.querySelector(
      "[data-product-json]"
    );
    if (!$new_productJsonData)
      return;
    window.productApp && typeof window.productApp.unmount == "function" && window.productApp.unmount();
    let newProductApp = createProductApp($new_v_product, $new_productJsonData);
    newProductApp && (window.productApp = newProductApp, window.productApp.mount(V_PRODUCT_SELECTOR)),
    window.Afterpay && typeof window.Afterpay.init == "function" && window.Afterpay.init($);
  }, initializeProductApp = ($v_product2, $productJsonData) => {
    let productApp = createProductApp($v_product2, $productJsonData);
    productApp && (productApp.mount(V_PRODUCT_SELECTOR), window.productApp = productApp), document.addEventListener(
    "shopify:section:load", handleSectionLoad);
  }, $v_product = document.querySelector(V_PRODUCT_SELECTOR);
  if (!$v_product || Shopify && Shopify.designMode)
    Shopify && Shopify.designMode && document.addEventListener("shopify:section:load", handleSectionLoad);
  else {
    let $productJsonData = $v_product.querySelector("[data-product-json]");
    $productJsonData && initializeProductApp($v_product, $productJsonData);
  }
})();
